import { Lang } from "@/i18n-config";
import { getTranslations } from "@/utils/i18n/get-translations";

export const getMetricPROptions = ({ lang }: { lang: Lang }) => {
  const { t } = getTranslations(lang);

  return [
    {
      value: "industryPR",
      label: t.analysis.overview.metricesCompareIndustry,
    },
    {
      value: "historyPR",
      label: t.analysis.overview.metricesCompareHistory,
    },
  ];
};
